'use client';

import { CheckOutlined, Close } from '@zoomit/icons';
import { Col, Flex, Spacing } from '@zoomit/primitives';
import { Typography, cssVar, theme } from '@zoomit/zoomit-ds';

import type { ProductSpecItem } from '../../types/compare';
import type { ProductGroupSpecification } from '../../types/single-product';

type Props = {
  productTitle: string;
  groupSpecs: ProductGroupSpecification[];
};

const SpecificationsContent = (props: Props) => {
  const { productTitle, groupSpecs } = props;

  const renderValue = (item: ProductSpecItem) => {
    if (item.type === 'Boolean') {
      return (
        <>
          {item.value === 'دارد' && (
            <Flex alignItems="center" gap={Spacing.x}>
              <CheckOutlined size="sm" fill={cssVar(theme.success1)} /> دارد
            </Flex>
          )}
          {item.value === 'ندارد' && (
            <Flex alignItems="center" gap={Spacing.x}>
              <Close size="sm" fill={cssVar(theme.error)} /> ندارد
            </Flex>
          )}
        </>
      );
    }
    return item.value ?? '-';
  };

  return (
    <div>
      <Typography
        tag="div"
        fontWeight="bold"
        lineHeight={1.8}
        fontSize={1.6}
        textColor={cssVar(theme.text)}
        spacing={{ mb: 'x3' }}
      >
        {productTitle}
      </Typography>
      {groupSpecs.map((group) => (
        <div
          className="border-grey6 mt-4 flex flex-col items-center gap-1 border-b border-solid pb-3 md:flex-row"
          key={group.title}
        >
          <Typography
            tag="span"
            fontSize={1.3}
            fontWeight="bold"
            lineHeight={2}
            textColor={cssVar(theme.primary2)}
            className="w-full md:w-30"
          >
            {group.title}
          </Typography>
          <Flex flexDirection="column" gap={0.6} className="mt-3 w-full md:mt-0">
            {group.specifications.map((field) => (
              <Flex key={field.id} className="hover:bg-grey7 w-full cursor-default p-0.5" gutter={2.4}>
                <Col size={6} md={3} className="text-right md:text-left">
                  <Typography fontWeight="bold" lineHeight={1.6}>
                    {field.title}
                  </Typography>
                </Col>
                <Col size={6} md={9}>
                  <Typography
                    className="whitespace-pre-wrap"
                    style={{ wordBreak: 'break-word' }}
                    variant="callout"
                    lineHeight={1.6}
                  >
                    {renderValue(field)}
                  </Typography>
                </Col>
              </Flex>
            ))}
          </Flex>
        </div>
      ))}
    </div>
  );
};

export default SpecificationsContent;
